import { useTranslation } from "react-i18next";
import { Plus, Trash2, Mail, Globe } from "lucide-react";
import { NeuButton, NeuInput } from "../../../components/neu/Neu";
import { Field } from "../../../components/neu/Field";
import { LogoUpload } from "./LogoUpload";

export const ContactTab = ({ form, setNested }) => {
  const { t } = useTranslation();
  const phones = form.contact.phones || [];

  const setPhone = (index, value) =>
    setNested("contact", "phones", phones.map((p, i) => (i === index ? value : p)));

  return (
    <div className="grid gap-5 sm:grid-cols-2">
      <div className="sm:col-span-2">
        <LogoUpload value={form.contact.logo_url} onChange={(url) => setNested("contact", "logo_url", url)} />
      </div>

      <Field
        label={t("branches.email")} testId="branch-contact_email" type="email"
        value={form.contact.email ?? ""} onChange={(v) => setNested("contact", "email", v)}
        accent="sky" icon={Mail}
      />
      <Field
        label={t("branches.website")} testId="branch-contact_website"
        value={form.contact.website ?? ""} onChange={(v) => setNested("contact", "website", v)}
        accent="violet" icon={Globe}
      />

      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("branches.phones")}</p>
        <div className="grid gap-2" data-testid="branch-phones">
          {phones.map((phone, index) => (
            <div key={index} className="flex gap-2">
              <NeuInput
                data-testid={`branch-phone-${index}`} value={phone} placeholder="+971 4 000 0000"
                onChange={(e) => setPhone(index, e.target.value)}
                className="border-s-4 border-s-emerald-500"
              />
              <NeuButton
                type="button" variant="danger" className="px-4 py-2"
                data-testid={`branch-phone-remove-${index}`}
                onClick={() => setNested("contact", "phones", phones.filter((_, i) => i !== index))}
              >
                <Trash2 className="h-4 w-4" />
              </NeuButton>
            </div>
          ))}
        </div>
        <NeuButton
          type="button" className="mt-3 flex items-center gap-2" data-testid="branch-phone-add"
          onClick={() => setNested("contact", "phones", [...phones, ""])}
        >
          <Plus className="h-4 w-4" /> {t("branches.addPhone")}
        </NeuButton>
      </div>
    </div>
  );
};
